export { default as ParcelTrackingTrolleyViewPage} from './trolley-view'